<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 32 32">
    <path :fill="themeColor"
      d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM22 8c1.105 0 2 1.343 2 3s-0.895 3-2 3-2-1.343-2-3 0.895-3 2-3zM11 9.752c1.864 0 3.188 0.698 3.188 1.79 0 0.231 0.119 1.344-0.005 1.55-0.463-0.768-1.713-1.318-3.182-1.318s-2.719 0.55-3.182 1.318c-0.124-0.206-0.005-1.319-0.005-1.55 0-1.092 1.324-1.79 3.187-1.79zM15.636 26c-3.726 0-6.996-2.009-8.84-5.030 2.2 1.721 6.079 2.057 10.165 1.249 4.383-0.866 7.785-2.861 9.014-5.519-0.677 5.249-5.047 9.299-10.339 9.299z">
    </path>
  </svg>
</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
